import script from "./VariantsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VariantsPage.vue?vue&type=script&setup=true&lang=js"

import "./VariantsPage.vue?vue&type=style&index=0&id=49f0bc55&lang=css"

const __exports__ = script;

export default __exports__